import React from "react";

/**
 * EkselensMark — the official Ekselens 5-bar geometric star.
 *
 * Renders the user-supplied brand PNG (transparent background, brand purple
 * #7737F6) as an <img>. Auto-scales by aspect ratio from the source PNG
 * dimensions (695 × 682 — extracted from the provided "Star purpleLRG_RGB.png").
 *
 * Props:
 *   - size:   px HEIGHT of the rendered mark. Width auto-scales.
 *   - color:  ignored (PNG is fixed brand purple). Kept for API back-compat
 *             with the previous SVG implementation.
 *   - className / style: extra styling hooks
 */
const SRC = "/ekselens-star.png";
const NATIVE_W = 695;
const NATIVE_H = 682;

const EkselensMark = ({
  size = 48,
  // eslint-disable-next-line no-unused-vars
  color,
  className = "",
  style = {},
  alt = "",
  loading = "lazy",
  ...rest
}) => {
  const width = Math.round((size * NATIVE_W) / NATIVE_H);
  return (
    <img
      src={SRC}
      alt={alt}
      width={width}
      height={size}
      draggable={false}
      loading={loading}
      decoding="async"
      className={className}
      style={{
        display: "block",
        flexShrink: 0,
        userSelect: "none",
        ...style,
      }}
      {...rest}
    />
  );
};

export default EkselensMark;
